import React from "react";
function splitValue(input) {
  const braceMap = { "{": 1, "}": -1 };
  const results = [];
  let braceLevel = 0;
  let value = "";
  for (let i = 0; i < input.length; i++) {
    const ch = input[i];
    const braceDelta = braceMap[ch] || 0;
    const braceLevelNext = braceLevel + braceDelta;
    if (braceLevel === 0 && braceLevelNext === 1) {
      results.push(value);
      value = "";
    } else if (braceLevel === 1 && braceLevelNext === 0) {
      results.push({
        type: "FormatElement",
        value
      });
      value = "";
    } else {
      value = value + ch;
    }
    braceLevel = braceLevelNext;
  }
  results.push(value);
  return results;
}
function parseChoice(input) {
  const [, n, opCode, translation] = input.match(/([0-9]+)([#<])(.*)/) || [];
  return {
    opCode,
    n: parseInt(n, 10),
    translation: parseMessageFormat(translation)
  };
}
function parseFormatElement(input) {
  const match = input.match(/^([-a-zA-Z0-9]+)(?:,([a-z]+)(?:,(.*))?)?/) || [];
  const result = {
    variable: match[1]
  };
  if (match[2]) {
    const [, formatType, style] = match.slice(1);
    switch (formatType) {
      case "choice":
        result.choices = style.split("|").map(parseChoice);
        break;
      default:
        throw new Error(`Unknown operation ${formatType} in translation string ${input}.`);
    }
  }
  return result;
}
function parseMessageFormat(input) {
  return splitValue(input).map((item) => {
    if (typeof item === "string") {
      return item;
    } else {
      return parseFormatElement(item.value);
    }
  });
}
function compileFormatElement({ variable, choices }) {
  const compiledChoices = choices && choices.map((choice) => ({
    ...choice,
    compile: compileMessageFormat(choice.translation)
  }));
  return (params) => {
    const value = params[variable];
    if (!compiledChoices) {
      return [value];
    } else {
      if (typeof value !== "number") {
        throw new Error(`${variable} should be a number, but got ${value}`);
      }
      const choice = compiledChoices.find((choice2) => {
        return choice2.opCode === "#" && choice2.n === value || choice2.opCode === "<" && choice2.n < value;
      }, compiledChoices);
      if (!choice) {
        throw new Error(`Couldn't find choice`);
      }
      return choice.compile(params);
    }
  };
}
function compileMessageFormat(parsed) {
  if (typeof parsed === "string") {
    return () => [parsed];
  } else if (Array.isArray(parsed)) {
    const compiledSubtranslations = parsed.map(compileMessageFormat);
    return (params) => {
      return compiledSubtranslations.map((f) => f(params)).reduce((l1, l2) => l1.concat(l2), []);
    };
  } else if (typeof parsed === "object") {
    return compileFormatElement(parsed);
  } else {
    throw new Error(`Unknown form`);
  }
}
let counter = 0;
function formatElement(message, params) {
  const tokens = parseMessageFormat(message);
  const compile = compileMessageFormat(tokens);
  const parts = compile(params);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, parts.map((part) => /* @__PURE__ */ React.createElement("span", { key: `t-elem-${counter++}` }, part)));
}
function formatString(message, params = {}) {
  const tokens = parseMessageFormat(message);
  const compile = compileMessageFormat(tokens);
  const parts = compile(params);
  return parts.join("");
}
export {
  formatElement,
  formatString
};
//# sourceMappingURL=format.js.map
